import { render, staticRenderFns } from "./face.vue?vue&type=template&id=3f56f450&scoped=true&"
import script from "./face.vue?vue&type=script&lang=js&"
export * from "./face.vue?vue&type=script&lang=js&"
import style0 from "./face.vue?vue&type=style&index=0&id=3f56f450&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f56f450",
  null
  
)

export default component.exports